import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { AppHealth, HealthRules, ServiceBusReport } from './models';

@Injectable({ providedIn: 'root' })
export class AppsService {
  private readonly http = inject(HttpClient);

  getAppsHealth(): Observable<AppHealth[]> {
    return this.http.get<AppHealth[]>(`${environment.baseUrl}/api/apps`);
  }

  getHealthRules(): Observable<HealthRules> {
    return this.http.get<HealthRules>(`${environment.baseUrl}/api/health-rules`);
  }

  getServiceBus(): Observable<ServiceBusReport> {
    return this.http.get<ServiceBusReport>(`${environment.baseUrl}/api/service-bus`);
  }
}
